interface AudioSectionProps {
  audioChecked: boolean;
  setAudioChecked: (checked: boolean) => void;
}

export default function AudioSection({ audioChecked, setAudioChecked }: AudioSectionProps) {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/50 to-black"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/30 rounded-2xl p-8 sm:p-12 shadow-2xl shadow-yellow-500/10">
          {/* Title */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full mb-4">
              <i className="ri-volume-up-line text-2xl text-black"></i>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3">
              Sistem Yöneticimizden Kısa Sesli Açıklama
            </h2>
            <p className="text-gray-400 text-base">
              Smart Hizmet sisteminin nasıl çalıştığını anlamak için sistem yöneticimiz tarafından hazırlanan kısa sesli bilgilendirmeyi dinleyiniz.
            </p>
          </div>

          {/* Audio Player */}
          <div className="bg-black/60 rounded-2xl p-8 mb-6 border border-yellow-500/20 shadow-inner shadow-yellow-500/5">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex-shrink-0">
                <i className="ri-mic-line text-xl text-black"></i>
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Sistem Yöneticisi Metin</p>
                <p className="text-gray-500 text-xs">Smart Hizmet Sesli Bilgilendirme</p>
              </div>
            </div>
            <audio 
              controls 
              className="w-full"
              style={{
                height: '54px'
              }}
            >
			  <source src="/audio/sh_ilkses.mp4" type="audio/mp4" />
              Tarayıcınız ses dosyasını desteklemiyor.
            </audio>
          </div>

          {/* Checkbox */}
          <div className="flex items-start gap-4 bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-6 cursor-pointer hover:bg-yellow-500/20 transition-all duration-300"
            onClick={() => setAudioChecked(!audioChecked)}
          >
            <div className={`flex-shrink-0 w-6 h-6 rounded border-2 flex items-center justify-center cursor-pointer transition-all duration-300 ${
              audioChecked 
                ? 'bg-gradient-to-br from-yellow-500 to-yellow-600 border-yellow-500' 
                : 'border-white/30 bg-black/30'
            }`}>
              {audioChecked && (
                <i className="ri-check-line text-black text-lg font-bold"></i>
              )}
            </div>
            <label className="text-white font-medium cursor-pointer flex-1">
              Sesli mesajı dinledim ve sistemin çalışma mantığını anladım.
            </label>
          </div>

          {!audioChecked && (
            <div className="mt-4 flex items-center gap-2 text-yellow-500 text-sm">
              <i className="ri-information-line"></i>
              <span>Devam etmek için lütfen sesli mesajı dinleyin ve onaylayın</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}